import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';

const TicketRulesModal = ({ open, onClose, ticketRules }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold' }}>Rules</DialogTitle>
      <DialogContent dividers>
        <List sx={{ pt: 0 }}>
          {ticketRules?.map((rule, index) => (
            <ListItem key={index} alignItems='flex-start' divider>
              <Box component='span' sx={{ mr: 2, minWidth: '24px', fontWeight: 'bold', pt: '12px' }}>
                {index + 1}.
              </Box>
              <ListItemText primary={rule.description} secondary={rule.detailed_description} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions sx={{ p: 2, justifyContent: 'center' }}>
        <Button onClick={onClose} variant='contained' color='primary'>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TicketRulesModal;
